<template>
  <v-main>
    <v-container fluid>
      <OSimpleDialog
        :maxWidth="800"
        ref="helpDialog"
        title="Formato dos Dados"
        :showButtons="false"
      >
        <v-card-text class="pa-6 d-flex items-start">
          <pre>{{ helpText }}</pre>
        </v-card-text>
      </OSimpleDialog>

      <div class="d-flex gap-6">
        <div class="w-1/3 h-600 d-flex flex-column justify-content-stretch">
          <div class="d-flex items-center gap-2">
            <label>Dados</label>
            <v-btn small icon>
              <v-icon small @click="() => $refs.helpDialog.open()"
                >mdi-help</v-icon
              >
            </v-btn>
            <v-btn small icon>
              <v-icon small>mdi-upload</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn small color="primary" @click="doParse">Parse</v-btn>
          </div>
          <textarea
            class="px-1 textarea-mono textarea-border flex-grow-1"
            v-model="strInput"
          />
        </div>

        <div class="w-2/3 h-600 overflow-y-scroll">
          <label>Timelines</label>

          <pre v-if="err != null">{{ err }}</pre>

          <div class="d-flex align-center mx-6">
            <!-- timeline name -->
            <div style="width: 150px"></div>

            <!-- plot -->
            <div style="flex-grow: 1; flex-shrink: 1; margin: 10px 0">
              <HorizontalTimelineTicks :scale="scale" :ticks="ticks" />
            </div>

            <!-- extra info -->
            <div class="ml-2" style="width: 50px"></div>
          </div>

          <div
            v-for="(row, idx) in timelines"
            :key="idx"
            class="d-flex align-center mx-6"
            style="border: 0px solid red"
          >
            <div
              class="text-body-2 my-1"
              style="width: 150px; border: 0px solid green"
            >
              {{ row.id }}
            </div>

            <div style="flex-grow: 1; flex-shrink: 1; margin: 10px 0">
              <HorizontalTimeline
                :scale="scale"
                :now="now"
                :items="row.items"
                :minHeightPx="20"
                :minWidthPx="minWidthPx"
              />
            </div>

            <div class="text-caption text-center ml-2" style="width: 50px">
              {{ row.extraInfo }}
            </div>
          </div>
        </div>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import HorizontalTimeline from 'oderon-vue/cpts/charts/HorizontalTimeline.vue'
import HorizontalTimelineTicks from 'oderon-vue/cpts/charts/HorizontalTimelineTicks.vue'
import OSimpleDialog from 'oderon-vue/cpts/dialogs/OSimpleDialog.vue'
import { makePercentScale } from 'oderon-vue/cpts/charts/svg-utils'
import moment from 'moment'

const helpText = `{
  minWidthPx: 4,
  timeRange: ['2025-01-31T12:00:00-0300', '2025-02-01T12:00:00-0300'],
  timelines: [
    {
      id: 'nome-da-timeline',
      extraInfo: 'texto-a-direita',
      items: [
        {
          timestamp,
          durationS,
          backgroundColor,
          cssClass,
          text
        },
        ...
      ]
    },
    ...
  ]
}`

export default {
  components: {
    HorizontalTimeline,
    HorizontalTimelineTicks,
    OSimpleDialog
  },
  data() {
    return {
      helpText,
      now: new Date(),
      strInput: null,
      timeRange: null,
      parsedData: null,
      timelines: [],
      err: null
    }
  },
  computed: {
    minWidthPx() {
      let px = this.parsedData && this.parsedData.minWidthPx
      return px || 4
    },
    ticks() {
      if (this.parsedData == null) return []
      return getTicks(this.parsedData.timeRange)
    },
    scale() {
      if (this.parsedData == null) return null
      let d0 = moment(this.parsedData.timeRange[0])
      let d1 = moment(this.parsedData.timeRange[1])
      return makePercentScale([d0, d1])
    }
  },
  methods: {
    doParse() {
      try {
        this.err = null
        this.parsedData = JSON.parse(this.strInput)
        this.timelines = this.parsedData.timelines || []
      } catch (err) {
        this.err = err
        this.parsedData = null
        this.timelines = []
      }
    }
  }
}

function getTicks(timeRange) {
  let hr = (x) =>
    moment(timeRange[0])
      .add(x, 'hour')
      .toISOString()

  let ticks = [
    { timestamp: hr(0), text: '00h', cssClass: 'lg' },
    { timestamp: hr(6), text: '06h', cssClass: 'lg' },
    { timestamp: hr(12), text: '12h', cssClass: 'lg' },
    { timestamp: hr(18), text: '18h', cssClass: 'lg' },
    { timestamp: hr(24), text: '24h', cssClass: 'lg end' }
  ]

  return ticks
}
</script>

<style lang="sass">
.textarea-mono
  font-family: 'Courier New', Courier, monospace
  white-space: pre

.textarea-border
  border: 1px solid #ccc
  border-radius: 8px

.line
  font-family: 'Courier New', Courier, monospace
  white-space: pre
  margin-left: 20px
  position: relative

  &.added
    color: green
    &:before
      content: '+'
      position: absolute
      left: -20px

  &.removed
    color: red
    &::before
      content: '-'
      position: absolute
      left: -20px
</style>
